"use strict";

exports.__esModule = true;
exports.default = exports.getInboxAuthors = void 0;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const getInboxAuthor = (_ref) => {
  let name = _ref.name,
      status = _ref.status,
      author = _objectWithoutPropertiesLoose(_ref, ["name", "status"]);

  if (name) {
    const names = name.split(" ");
    name = names[0];

    if (name.length > 12) {
      name = name.substr(0, 12) + ".";
    }

    if (names.length > 1) {
      for (let i = 1; i < names.length; i++) {
        name = name + " " + names[i].substr(0, 1) + ".";
      }
    }
  }

  return _extends({}, author, {
    name: name,
    status: status
  });
};

const getInboxAuthors = ({
  messages = []
}) => {
  let read = [];
  let readAuthors = [];
  let unread = [];
  let unreadAuthors = [];
  let unique = [];
  let uniqueAuthors = [];
  messages.map(message => {
    let author = message.author;
    const _author = author,
          name = _author.name;
    const names = name.split(" ");
    const firstName = names[0];
    const lastName = names[names.length - 1];
    const shortName = firstName + " " + lastName.substr(0, 1) + ".";
    author = _extends({}, author, {
      firstName: firstName,
      lastName: lastName,
      shortName: shortName,
      unread: message.unread
    });

    if (message.unread && !unread.includes(name)) {
      unread.push(name);
      unreadAuthors.push(author);
    } else if (!read.includes(name)) {
      read.push(name);
      readAuthors.push(author);
    }

    if (!unique.includes(name)) {
      unique.push(name);
      uniqueAuthors.push(author);
    }
  });
  return {
    authors: uniqueAuthors,
    authorNames: unique
  };
  /*
  return {
      unique: uniqueAuthors,
      read: readAuthors,
      unread: unreadAuthors
  };
  */

  let authors = [];

  if (unique.length <= 2) {
    authors = unique;
  }

  if (read.length && unread.length) {
    authors = unread;
    authors.push(read[0]);
  }

  return authors;
};

exports.getInboxAuthors = getInboxAuthors;
var _default = getInboxAuthors;
exports.default = _default;